import { UnloadingPointInfo } from '../domain/unloadingPoint';
import UnloadingPointRepository from '../infractructure/repositories/unloadingPointRepository';

class GetUnloadingPointInfoUseCase {
  private readonly _repository = UnloadingPointRepository;

  execute(): Promise<UnloadingPointInfo> {
    return this._repository.getUnloadingPointInfoData();
  }
}

export default new GetUnloadingPointInfoUseCase();
export { GetUnloadingPointInfoUseCase };
